/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

export default class SignalRange extends EmberObject {
  maxMagnitudeObject = null;
  indexObject = null;
  smallestMultiplier = null;
  orderOptimizationFrequencyArray = null;
  vRef = null;
  whoAmI = 'app/models/stages/signal-range.js';
  @computed('maxMagnitudeObject', 'smallestMultiplier') get slewRate() {
    var smallestMultiplier = this.smallestMultiplier;
    var maxMagnitudeObject = this.maxMagnitudeObject;
    var result = maxMagnitudeObject.slewRate * smallestMultiplier;
    return result;
  }

  @computed('indexObject', 'orderOptimizationFrequencyArray') get slewRateFreq() {
    var indexObject = this.indexObject;
    var orderOptimizationFrequencyArray = this.orderOptimizationFrequencyArray;
    var result = orderOptimizationFrequencyArray[indexObject.slewRate];
    return result;
  }

  @computed('vRef', 'maxMagnitudeObject', 'smallestMultiplier') get minInput() {
    var vRef = this.vRef;
    var maxMagnitudeObject = this.maxMagnitudeObject;
    var smallestMultiplier = this.smallestMultiplier;
    var result = vRef + -1 * maxMagnitudeObject.input * smallestMultiplier;
    return result;
  }

  @computed('vRef', 'maxMagnitudeObject', 'smallestMultiplier') get maxInput() {
    var vRef = this.vRef;
    var maxMagnitudeObject = this.maxMagnitudeObject;
    var smallestMultiplier = this.smallestMultiplier;
    var result = smallestMultiplier * maxMagnitudeObject.input + vRef;
    return result;
  }

  @computed('indexObject', 'orderOptimizationFrequencyArray') get inputFrequency() {
    var indexObject = this.indexObject;
    var orderOptimizationFrequencyArray = this.orderOptimizationFrequencyArray;
    var result = orderOptimizationFrequencyArray[indexObject.input];
    return result;
  }

  @computed('vRef', 'maxMagnitudeObject', 'smallestMultiplier') get minOutput() {
    var vRef = this.vRef;
    var maxMagnitudeObject = this.maxMagnitudeObject;
    var smallestMultiplier = this.smallestMultiplier;
    var result = vRef + -1 * maxMagnitudeObject.output * smallestMultiplier;
    return result;
  }

  @computed('vRef', 'maxMagnitudeObject', 'smallestMultiplier') get maxOutput() {
    var vRef = this.vRef;
    var maxMagnitudeObject = this.maxMagnitudeObject;
    var smallestMultiplier = this.smallestMultiplier;
    var result = smallestMultiplier * maxMagnitudeObject.output + vRef;
    return result;
  }

  @computed('indexObject', 'orderOptimizationFrequencyArray') get outputFrequency() {
    var indexObject = this.indexObject;
    var orderOptimizationFrequencyArray = this.orderOptimizationFrequencyArray;
    var result = orderOptimizationFrequencyArray[indexObject.output];
    return result;
  }
}
